export default __webpack_public_path__ + "static/media/30.33ab2df6.png";